"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const hyperapp_1 = require("../../../hyperapp");
const classNames = require("classnames");
exports.UiKitEField = (props, children) => (hyperapp_1.h("div", Object.assign({}, props, { className: classNames('e-field', props && props.className) }), children));
//# sourceMappingURL=uikit-e-field.js.map